export const nav = {
    permissao: 'deck.sprints:ver',
    section: 'Trabalho',
    title: 'Sprints',
    icon: 'flag',
    route: '/sprints',
    sequence: 4,
};

export default [
    {
        path: '/sprints',
        name: 'sprints',
        component: () => import('@/modules/quadro/pages/EscolherProjetoPage.vue'),
        props: { destino: 'sprints-projeto' },
        meta: { requiresAuth: true, permissao: 'deck.sprints:ver' },
    },
    {
        path: '/sprints/:projectKey',
        name: 'sprints-projeto',
        component: () => import('./pages/SprintsPage.vue'),
        props: true,
        meta: { requiresAuth: true, permissao: 'deck.sprints:ver' },
    },
    {
        path: '/sprints/:projectKey/:sprintId',
        name: 'sprint',
        component: () => import('./pages/SprintPage.vue'),
        props: true,
        meta: { requiresAuth: true, permissao: 'deck.sprints:ver' },
    },
];
